import { useDeleteManyQuoteRequestLine } from "#modules/quoteRequestLines/view/useDeleteManyQuoteRequestLine";
import { useDeleteQuoteRequestLine } from "#modules/quoteRequestLines/view/useDeleteQuoteRequestLine";

export const useDeleteQuoteRequestLineOrBatch = (options?: {
  onSuccess?: (deletedIds?: string[]) => void;
}) => {
  const { deleteQuoteRequestLine, isPending: isDeleteSinglePending } = useDeleteQuoteRequestLine({
    onSuccess: () => options?.onSuccess?.(),
  });
  const { deleteManyQuoteRequestLine, isPending: isDeleteManyPending } =
    useDeleteManyQuoteRequestLine({
      onSuccess: (deletedIds) => options?.onSuccess?.(deletedIds),
    });

  const deleteQuoteRequestLineOrBatch = (
    quoteRequestLineIdsInBatch: string[],
    quoteRequestLineId: string,
  ) => {
    if (quoteRequestLineIdsInBatch.length > 1) {
      deleteManyQuoteRequestLine(quoteRequestLineIdsInBatch);
      return;
    }
    deleteQuoteRequestLine(quoteRequestLineId);
  };

  return {
    deleteQuoteRequestLineOrBatch,
    isPending: isDeleteSinglePending || isDeleteManyPending,
  };
};
